module.exports = __webpack_public_path__ + "static/media/student3.7fc54f4b.svg";